"use client";

import type React from "react";

import { Globe, Lock, User, Users } from "lucide-react";

import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

function VisibilityDropdown({
  visibility,
  setVisibility,
}: {
  visibility: "public" | "friends" | "private" | "only me";
  setVisibility: (value: "public" | "friends" | "private" | "only me") => void;
}) {
  const visibilityIcons = {
    "public": <Globe className="h-4 w-4" />,
    "friends": <Users className="h-4 w-4" />,
    "private": <Lock className="h-4 w-4" />,
    "only me": <User className="h-4 w-4" />,
  };

  const visibilityLabels = {
    "public": "Public",
    "friends": "Friends",
    "private": "Private",
    "only me": "Only me",
  };

  const visibilityDescriptions = {
    "public": "Anyone can see this post",
    "friends": "Only your friends can see this post",
    "private": "Only you and mentioned users can see this post",
    "only me": "Only you can see this post",
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1">
          {visibilityIcons[visibility]}
          <span className="hidden sm:inline">{visibilityLabels[visibility]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(visibilityIcons).map(([key, icon]) => (
          <DropdownMenuItem
            key={key}
            onClick={() => setVisibility(key as any)}
            className="gap-2"
          >
            {icon}
            <div>
              <p className="font-medium">{visibilityLabels[key as keyof typeof visibilityLabels]}</p>
              <p className="text-xs text-muted-foreground">
                {visibilityDescriptions[key as keyof typeof visibilityDescriptions]}
              </p>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default VisibilityDropdown;
